export const animation = {
  maskShowDuration: 0.6,
  maskHideDuration: 0.6,
  wordDuration: 0.006,
  lineDuration: 0.05,
  blockThreshold: 0.2,
}
